import ConfigurablePane from './_configurable-pane.js'
import ConfigurableText from './_configurable-text.js'
import ConfigurablePosition from './_configurable-position.js'
import ConfigurableBackground from './_configurable-background.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableSize from './_configurable-size.js'
import FlexPane from './_flex-pane.js'
import Animation from './_animation.js'

export default {
  name: 'RedCard',
  values: {
    bannerAnimationDuration: 2000,
    isShownOneRedCard: false,
    style: {
      card: {
        minHeight: '14px',
        minWidth: '10px',
        height: '14px',
        margin: '0px 4px',
        transform: 'rotate(15deg)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
        ],
      },
      text: {
        transform: 'rotate(-15deg)',
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
      bannerContainer: {
        textAlign: 'center',
        transition: '.4s',
        right: 0,
        top: 0,
        padding: '0 8px',
        minWidth: '81px',
        boxSizing: 'border-box',
        width: 'max-content',
        $mixin: [
          {
            configSet: ConfigurablePosition,
          },
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurableText,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
          {
            configSet: ConfigurableSize,
          },
        ],
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'row',
        },
      },
    },
    animation: {
      configSet: Animation,
      configValues: {
        animationDuration: '.7s',
        animationTimingFunction: 'linear',
        animationIterationCount: '2',
        keyframes: {
          from: {
            opacity: '100%',
          },
          to: {
            opacity: '0%',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
